import Button from '@material-ui/core/Button';
import { GA_EVENT_TREE } from '../../../../gaConstants';
import React from 'react';
import MicrosoftIcon from '../../../../MyComponents/icons/MicrosoftIcon';

export const MicrosoftLoginButton = ({ handleLogin, classes }) => {
    return (
        <div style={{ paddingLeft: '1.5rem' }}>
            {!window.isTeams ? (
                <Button
                    size="large"
                    variant="contained"
                    className={classes.loginButtonSmall}
                    style={{ color: 'white' }}
                    onClick={() => {
                        window.logAppActivity(GA_EVENT_TREE.mainPage.links.microsoftLogin);
                        handleLogin('/microsoft');
                    }}
                    startIcon={<MicrosoftIcon className={classes.customIcon} />}
                />
            ) : null}
        </div>
    );
};
